export default "__VITE_ASSET__DY4ABnvJ__"